module.exports = __webpack_public_path__ + "img/bgBluesquare.97e7e132.png";